module.exports = __webpack_public_path__ + "a7a8599e617040e11deb7aff7a1794d3.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/furnitures/floor_items/magic-book.png
// module id = 979
// module chunks = 0